import React, { useState } from 'react';
import { Button, Modal, ModalTitle, Stack } from 'react-bootstrap';
import { AccreditationType } from 'graphql/__generated__/graphql';
import { LoadingSpinner } from 'components/LoadingSpinner';

interface AbandonApplicationModalProps {
    onConfirm: () => void;
    accreditationType: AccreditationType;
}

const AbandonApplicationModal: React.FC<AbandonApplicationModalProps> = ({
    accreditationType,
    onConfirm,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const handleConfirm = () => {
        setIsDeleting(true);
        onConfirm();
    };

    const renderModalFooter = () => {
        if (isDeleting) {
            return (
                <>
                    <p>Please wait</p>
                    <LoadingSpinner />
                </>
            );
        }

        return (
            <Stack direction="horizontal" className="mx-auto" gap={4}>
                <Button
                    variant="outline-secondary"
                    data-testid="cancel-delete-btn"
                    onClick={handleCloseModal}
                >
                    Cancel
                </Button>
                <Button
                    variant="outline-danger"
                    data-testid="confirm-delete-btn"
                    onClick={handleConfirm}
                    disabled={isDeleting}
                >
                    Confirm: abandon application
                </Button>
            </Stack>
        );
    };

    return (
        <>
            <Button
                variant="link"
                className="btn-link link-underline"
                onClick={handleOpenModal}
                disabled={isModalOpen}
            >
                <i className="bi-trash" /> Abandon application
            </Button>

            <Modal show={isModalOpen} onHide={handleCloseModal}>
                <Modal.Header closeButton className="border-0 align-items-start">
                    <ModalTitle>
                        Are you sure you want to abandon your {accreditationType.name} application?
                    </ModalTitle>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        This will prevent your supervisors from accessing it, and you'll lose any
                        fees paid towards it. It can't be undone.
                    </p>
                </Modal.Body>

                <Modal.Footer className="justify-content-center">
                    {renderModalFooter()}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AbandonApplicationModal;
